import { createAction } from '@reduxjs/toolkit';
import {
    IFetchEmailTemplatesPayload,
    ISaveEmailTemplatePayload,
    IDeleteEmailTemplatePayload,
    ISendEmailPayload,
    IEmailTemplate,
    IProductEmailCategory,
    types,
} from './types';
import { IErrorType } from '../../constants/types';

export const fetchEmailTemplates = createAction<IFetchEmailTemplatesPayload>(types.FETCH_EMAIL_TEMPLATES);
export const fetchEmailTemplatesSuccess = createAction<any>(types.FETCH_EMAIL_TEMPLATES_SUCCESS);
export const fetchEmailTemplatesFail = createAction<IErrorType>(types.FETCH_EMAIL_TEMPLATES_FAIL);

export const saveEmailTemplate = createAction<ISaveEmailTemplatePayload>(types.SAVE_EMAIL_TEMPLATE);
export const saveEmailTemplateSuccess = createAction<IEmailTemplate>(types.SAVE_EMAIL_TEMPLATE_SUCCESS);
export const saveEmailTemplateFail = createAction<IErrorType>(types.SAVE_EMAIL_TEMPLATE_FAIL);

export const deleteEmailTemplate = createAction<IDeleteEmailTemplatePayload>(types.DELETE_EMAIL_TEMPLATE);
export const deleteEmailTemplateSuccess = createAction<string>(types.DELETE_EMAIL_TEMPLATE_SUCCESS);
export const deleteEmailTemplateFail = createAction<IErrorType>(types.DELETE_EMAIL_TEMPLATE_FAIL);

export const sendEmail = createAction<ISendEmailPayload>(types.SEND_EMAIL);
export const sendEmailSuccess = createAction<any>(types.SEND_EMAIL_SUCCESS);
export const sendEmailFail = createAction<IErrorType>(types.SEND_EMAIL_FAIL);

export const setCurrentTemplate = createAction<IEmailTemplate | null>(types.SET_CURRENT_TEMPLATE);

export const fetchProductEmailCategories = createAction(types.FETCH_PRODUCT_EMAIL_CATEGORIES);
export const fetchProductEmailCategoriesSuccess = createAction<IProductEmailCategory[]>(
    types.FETCH_PRODUCT_EMAIL_CATEGORIES_SUCCESS,
);
export const fetchProductEmailCategoriesFail = createAction<IErrorType>(types.FETCH_PRODUCT_EMAIL_CATEGORIES_FAIL);
